import { CloseIcon, HamburgerIcon } from '@chakra-ui/icons';
import type { FC } from 'react';
import { useEffect, useMemo, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Header: FC = () => {
  const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  const navItems = useMemo(
    () => [
      {
        label: 'Om os',
        to: { pathname: '/', hash: '#om-os' },
        active: pathname === '/',
      },
      {
        label: 'Ejendomme',
        to: '/ejendomme',
        active: pathname === '/ejendomme' || pathname.startsWith('/ejendom/'),
      },
      {
        label: 'Lejerinformation',
        to: '/lejerinfo',
        active: pathname === '/lejerinfo',
      },
      {
        label: 'Kontakt',
        to: '/kontakt',
        active: pathname === '/kontakt',
      },
    ],
    [pathname]
  );

  return (
    <header className="site-nav">
      <div className="section-wrap">
        <div className="site-nav__inner">
          <Link className="site-logo" to="/">
            Toft Ejendomme
          </Link>

          <div className="site-nav__desktop">
            <nav className="site-nav__links" aria-label="Hovednavigation">
              {navItems.map((item) => (
                <Link
                  key={item.label}
                  className={`site-nav-link${item.active ? ' is-active' : ''}`}
                  to={item.to}
                >
                  {item.label}
                </Link>
              ))}
              <a
                className="site-nav-link"
                href="https://www.boligportal.dk/dl/toft/"
                target="_blank"
                rel="noopener noreferrer"
              >
                Ledige lejemål ↗
              </a>
            </nav>

            <Link className="site-btn site-btn--primary" to={{ pathname: '/', hash: '#tilmelding' }}>
              Skriv dig op
            </Link>
          </div>

          <button
            className="site-nav__hamburger"
            aria-label={isOpen ? 'Luk navigation' : 'Åbn navigation'}
            aria-expanded={isOpen}
            aria-controls="site-mobile-nav"
            onClick={() => setIsOpen((value) => !value)}
            type="button"
          >
            {isOpen ? <CloseIcon /> : <HamburgerIcon />}
          </button>
        </div>

        <div className={`site-nav__mobile${isOpen ? ' open' : ''}`} id="site-mobile-nav">
          <nav className="site-nav__mobile-panel" aria-label="Mobilnavigation">
            {navItems.map((item) => (
              <Link key={item.label} to={item.to}>
                {item.label}
              </Link>
            ))}
            <a
              href="https://www.boligportal.dk/dl/toft/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Ledige lejemål ↗
            </a>
            <Link to={{ pathname: '/', hash: '#tilmelding' }}>Skriv dig op →</Link>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
